<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-economics-outlook-html">
      <div class="two-col-wrapper">
        <div class="col-inner">
          <p v-html="helpJsonContent.us_economic_outlook.body"></p>
        </div>
        <div class="col-inner">
          <div class="table-responsive">
            <table class="tr-data-table">
              <thead>
                <tr>
                  <th>{{ helpJsonContent.table_head.col1 }}</th>
                  <th>{{ helpJsonContent.table_head.col2 }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="row in helpJsonContent.table" :key="row">
                  <tr>
                    <td style="text-align: center">{{ row.col1 }}</td>
                    <td style="text-align: center">{{ row.col2 }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <h4 class="margin-top">{{ helpJsonContent.current_data.bg }}</h4>
      <p>
        <img
          :src="
            images_path + helpJsonContent.current_data.image1.attributes.href
          "
          alt="Trends Report Image"
        />
      </p>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'EconomicOutlookTemplate',
    props: {
      cwaData: {
        type: Object,
        required: false,
        default: () => ({
          OverviewText: '',
          ImageBase64: '',
        }),
      },
    },
    data: () => ({}),
    created() {},
    mounted() {},
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
